import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

declare var moment: any;

@Injectable()
export class ShareServicesProvider {

  lang:any;
  langName = "th";
  label:any;
  menu:any;
  notificationBadge = 0;
  userFname = localStorage.getItem('LiMemberFname');
  // serviceUrl = "http://li.buu.ac.th/admin/web/index.php?r=";
  serviceUrl = "/admin/web/index.php?r=";
  
  constructor(
    public http: Http
  ) {
    // console.log('Hello ShareServicesProvider Provider');
  }
  /**
   * 
   */
  getLabel(){
    return this.http.get('assets/json/lang.json?r='+this.stringGen(5))
    .map(res => res.json().data);
  }
  /**
   * 
   */
  checkLang() : void{
    if(localStorage.getItem('LiMemberLang')){
      this.lang = localStorage.getItem('LiMemberLang');
    }else{
      this.lang = 0;
    }
    this.changeLangName(this.lang);
  }
  /**
   * 
   * @param langid 
   */
  switchLang(langid){
    localStorage.setItem('LiMemberLang',langid);
    window.location.reload(true);
  }
  /**
   * sign in to receive Token
   * @param signinData = user authen data
   */
  doSignIn(signinData:any) {
    //***ต้้องแก้เป็น POST ****
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/login-member', { signinData }, options).map(res => res.json().data);
  }
  /**
   * sign out and invoke token
   * @param token = token to invoke
   */
  doSignOut(token:any) { //sign out เพื่อล้าง token
    //***ต้้องแก้เป็น POST ****
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/logout', { }, options).map(res => res.json().data);
  }
  /**
   * use for save token to localStorage
   * @param token = active token
   */
  saveToken(token:any,fname:any) : void {
    localStorage.setItem('LiMemberToken',token);
    localStorage.setItem('LiMemberFname',fname);
    this.userFname = fname;
  }
  /**
   * return token from localStorage
   */
  getToken() { 
    // return "test12345678";
    return localStorage.getItem('LiMemberToken');
  }
  /**
   * remove token from localStorage
   */
  clearToken() : void { 
    localStorage.removeItem('LiMemberToken');
    localStorage.removeItem('LiMemberFname');
    this.userFname = '';
    this.notificationBadge = 0;
  }
  /**
   * use for check current token and renew token *must alway call saveToken() in callback to save new token
   * @param token = active token
   */
  checkToken(token:any) {
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/check-token', { }, options).map(res => res.json().data);
  }
  /**
   * 
   * @param id 
   * @param type 
   */
  checkID(idData){
    let headers = new Headers({ 'Content-Type': 'application/json'});
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/check-member', idData , options).map(res => res.json().data);
  }
  /**
   * use for submit data to register new user
   * @param registerData = register data obj
   */
  register(registerData:any){ 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/register-member',  registerData ,options).map(res => res.json().data);
  }
  /**
   * 
   * @param token 
   */
  getProfile(token:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.get(this.serviceUrl+'api/get-member-profile',options).map(res => res.json().data);
  }
  /**
   * 
   * @param token 
   * @param updateData 
   */
  updateProfile(token:any,updateData:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/update-member-profile', updateData ,options).map(res => res.json().data);
  }
  /**
   * 
   * @param token 
   * @param oldPassword 
   * @param newPassword 
   */
  changePassword(token:any,oldPassword:any,newPassword:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/change-password', {'OldPassword':oldPassword,'NewPassword':newPassword} ,options).map(res => res.json().data);
  }
  /**
   * 
   * @param email 
   */
  resetPassword(email:any){
    let headers = new Headers({ 'Content-Type': 'application/json'});
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/forget-password', email ,options).map(res => res.json().data);
  }
  /**
   * 
   * @param page 
   * @param type 
   */
  getCourseList(page:any,type:any){
    return this.http.get(this.serviceUrl+'api/get-course-list&page='+page+'&courseType='+type).map(res => res.json().data);
  }
  /**
   * 
   * @param courseID 
   */
  getCourseDetail(courseID:any){
    return this.http.get(this.serviceUrl+'api/get-course-detail&courseID='+courseID).map(res => res.json().data);
  }
  /**
   * 
   * @param token 
   * @param any 
   */
  getEvaluationForm(token:any,courseID:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.get(this.serviceUrl+'api/get-evaluation-form&courseID='+courseID,options).map(res => res.json().data);
  }
  /**
   * 
   * @param token 
   * @param courseID 
   */
  signUpCourse(token:any,courseID:any,){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/sign-up-course',{ "CourseID" : courseID },options).map(res => res.json().data);
  }
  /**
   * 
   * @param token 
   * @param courseID 
   * @param fromData
   * @param fileObj = file obj
   */
  signUpTest(token:any,courseID:any,fromData:any,fileObj:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/save-evaluation',{ "CourseID" : courseID, "List": fromData, "RegisterPic": fileObj},options).map(res => res.json().data);
  }
  /**
   * 
   * @param token 
   */
  getSignUpStatus(token:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.get(this.serviceUrl+'api/get-signup-list',options).map(res => res.json().data);
  }
  /**
   * use for upload proof of payment 
   * @param token = active token
   * @param registerID 
   * @param payDate = date of transfer
   * @param payTime = time of transfer
   * @param fileObj = file obj
   */
  confirmPayment(token:any,registerID:any,payDate:any,payTime:any,fileObj:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    let data = {'RegisterID':registerID,'FileObj':fileObj,'PayDate':payDate,'PayTime':payTime}
    return this.http.post(this.serviceUrl+'api/confirm-payment', data , options).map(res => res.json().data);
  }
  /**
   * 
   * @param token 
   * @param registerID 
   * @param fileObj 
   */
  sendPhoto(token:any,registerID:any,fileObj:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    let data = {'RegisterID':registerID,'FileObj':fileObj}
    return this.http.post(this.serviceUrl+'api/send-photo', data , options).map(res => res.json().data);
  }
  /**
   * 
   * @param token 
   */
  getHistoryList(token:any,page:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.get(this.serviceUrl+'api/get-member-history&page='+page,options).map(res => res.json().data);
  }
  /**
   * 
   * @param courseID 
   */
  getHistoryDetail(token:any,registerID:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.get(this.serviceUrl+'api/get-history-detail&registerID='+registerID,options).map(res => res.json().data);
  }
  /**
   * 
   * @param token 
   * @param registerID 
   */
  cancelRegister(token:any,registerID:any){
    let headers = new Headers({ 'Content-Type': 'application/json','TOKEN':token });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.serviceUrl+'api/cancel-register', {'RegisterID' : registerID } , options).map(res => res.json().data);
  }
  /****** utility function *******/
  /**
   * 
   * @param len 
   */
  stringGen(len){
    let text = '';
    let charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
    for( let i=0; i < len; i++ ){
      text += charset.charAt(Math.floor(Math.random() * charset.length));        
    }
    return text;
  }
  /**
   * 
   * @param id 
   */
  changeLangName(id:any) :void {
    switch (id) {
      case '1':
        this.langName = 'en';
        break;
      case '2':
        this.langName = 'zh-cn';
        break;
      default:
        this.langName = 'th';
        break;
    }
  }
  /**
   * 
   * @param dataData 
   */
  showDate(dataData:any){
    //set moment locale
    moment.locale(this.langName);
    return moment(dataData).format("LL");
  }
  /**
   * 
   * @param dataData 
   */
  showDateTime(dataData:any){
    //set moment locale
    moment.locale(this.langName);
    return moment(dataData).format("LLL");
  }
  /**
   * 
   * @param dataData 
   */
  fromNow(dataData:any){
    moment.locale(this.langName);
    if(!dataData) {
      return '';
    }
    return moment(dataData).fromNow();
  }
  
  /**
   * detect IE
   * returns version of IE or false, if browser is not Internet Explorer
   */
  detectIE() {
    let ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // IE 12 / Spartan
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge (IE 12+)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      let rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    let edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/providers/share-services/share-services.ts